// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"361":"a6907e14","460":"f7703ed6","673":"5122b377"}[chunkId] + ".chunk.js");